import { useMemo } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { ProjectSettingsForm } from '../components/ProjectSettingsForm'
import type { ProjectDocument } from '@/lib/db/rxdb/schemas/project'
import { useProjects } from '@/lib/db/rxdb/hooks'
import useLoginStore from '@/store/LoginStore'
import { usePageLayout } from '@/hooks/usePageLayout'
import TaskSidebar from '@/components/app/sidebars/task'

export const Route = createFileRoute(
  '/_AppWrapper/_AppLayout/$workspaceSlug/projects/$projectKey/settings',
)({
  component: ProjectSettingsPage,
})

export default function ProjectSettingsPage() {
  const { workspaceSlug, projectKey: projectKeyParam } = Route.useParams()
  const projectKey = projectKeyParam.toUpperCase()
  const workspaceId = useLoginStore((state) => state.workspaceId)
  usePageLayout({ sidebarContent: <TaskSidebar /> })

  const { projects, isLoading } = useProjects()

  const project = useMemo<ProjectDocument | null>(() => {
    return (
      projects.find((entry) => {
        if (entry.isDeleted) return false
        if (entry.projectKey !== projectKey) return false
        if (workspaceId && entry.envId !== workspaceId) return false
        return true
      }) ?? null
    )
  }, [projects, projectKey, workspaceId])

  return (
    <ProjectSettingsForm
      project={project}
      isLoading={isLoading}
      backLinkTo="/$workspaceSlug/projects/$projectKey"
      backLinkParams={{ workspaceSlug, projectKey: projectKeyParam }}
    />
  )
}
